import { render, staticRenderFns } from "./ImageRecord.vue?vue&type=template&id=6794a65a&scoped=true"
import script from "./ImageRecord.vue?vue&type=script&lang=js"
export * from "./ImageRecord.vue?vue&type=script&lang=js"
import style0 from "./ImageRecord.vue?vue&type=style&index=0&id=6794a65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794a65a",
  null
  
)

export default component.exports